import React from "react";

function InfoCircleIcon() {
  return (
    <span className="anticon anticon-infocircle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 2.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm1.38 6.873v5.5H9.63v-5.5h2.75zM11 5.498a1.375 1.375 0 11.002 2.75A1.375 1.375 0 0111 5.498z"
        ></path>
      </svg>
    </span>
  );
}

export default InfoCircleIcon;